<template>
    <div class="uk-margin-large-top">
      <div class="uk-grid uk-grid-small uk-text-center uk-flex-center">
        <div class="uk-width-1-1@s uk-width-1-1@m uk-width-1-2@l">
          <div class="uk-card uk-card-body uk-card-default">
            <h4 class="uk-card-title">.commodity</h4>
            <form action="" v-on:submit.prevent="signIn">
              <div class="uk-margin">
                <div class="uk-inline">
                  <span class="uk-form-icon" uk-icon="icon: mail"></span>
                  <input class="uk-input uk-form-large" type="email" placeholder="Enter the email" name="email" v-model="email" required>
                </div>
              </div>
              <div class="uk-margin">
                <div class="uk-inline">
                  <span class="uk-form-icon" uk-icon="icon: lock"></span>
                  <input class="uk-input uk-form-large" type="password" name="password" placeholder="Enter the password" v-model="password" required>
                </div>
              </div>
              <div v-if="error" class="uk-margin">
                <div class="uk-inline">
                  <div class="uk-alert uk-alert-danger">
                    {{ errorText }}
                  </div>
                </div>
              </div>
              <div class="uk-margin">
                <div class="uk-inline">
                  <button class="uk-button uk-button-large uk-button-primary">Sign in</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import $ from 'jquery';
export default {
  name: "Login",
  data() {
    return {
      error: false,
      email: '',
      password: '',
      errorText: '',
    }
  },
  methods: {
    signIn(e) {
      const self = this;
      self.errorText = '';
      self.error = false;
      self.$request().post("/user/sign_in", {
        email: self.email,
        password: self.password
      }).then(r => {
        r = self.$request().successHandler(r).data.passphrase;
        localStorage.setItem('passphrase', r.passphrase);
        localStorage.setItem('user_id', r.user_id);
        localStorage.setItem('passphrase_id', r.id);
        self.$request().passphrase = r.passphrase;
        self.$request().post(self.$request().tokenUri, {
          passphrase: r.passphrase
        }).then(r => {
          r = self.$request().successHandler(r).data.token;
          localStorage.setItem('token', r.jwt);
          self.$request().token = r.jwt;
          self.$router.push('/');
        }).catch(e => {
          self.errorText = 'Something went wrong. Please try again later.';
          self.error = true;
        });
      }).catch(e => {
        self.errorText = 'Wrong email or password';
        self.error = true;
      });
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Login.vue